import { TranslationMessages } from 'react-admin';
import englishMessages from 'ra-language-english';

const customEnglishMessages: TranslationMessages = {
    ...englishMessages,
    pos: {
        configuration: 'Configuration',
        language: 'Language',
        auth: {
            sign_up: 'Sign Up',
        },
        health: 'Health',
        upload: 'Upload'
    },
    resources: {
        products:{
            name: 'Products',
            fields: {
                id: 'Id',
                title: 'Title',
                description: 'Descripton',
                upload_images: 'UploadImages',
                short_description: 'ShortDescription',
                long_description: 'LongDescription',
                nutrition: 'Nutrition',
                category: 'Category',
                images: 'Images',
                uom: 'Uom',
                size: 'Size',
                price: 'Price',
                featured_image: 'FeaturedImage',
                discounted_price: 'DiscountedPrice'

            }
        },
        config: {
            name: 'Configs',
            fields: {
                id: 'Id',
                title: 'Title',
                description:'Description',
                link_url: 'LinkUrl',
                image_url: 'ImageUrl',
                config_group:'ConfigGroup',
                name:'Name',
                type: 'Type',
                show_title: 'ShowTitle',
                header:'Header'
            }
        },
        banners: {
            name: 'Banners',
            fields: {
                title: 'Title',
                location:'Location',
                image_url: 'ImageUrl',
            }
        },
        categories: {
            name: 'Categories',
            fields: {
                id: 'Id',
                title: 'Title',
                description: 'Descripton',
            }
        },
        videos: {
            name: 'Videos',
        },
        recipes: {
            name: 'Recipes',
            fields: {
                id: 'Id',
                title: 'Title',
                description: 'Descripton',
                content: 'Content',
                images: 'Images',
                type: 'Type',
                prep_time: 'Prep time',
                total_time: 'Total time',
                servings: 'Servings',
                calories: 'Calories',
                views: 'Views'
            }
        },
        news: {
            name: 'News',
            fields: {
                id: 'Id',
                title: 'Title',
                description: 'Descripton',
                content: 'Content',
                featured_image: 'Featured image',
                thumbnail: 'Thumbnail',
                views: 'Views'
            }
        },
        cms: {
            name: 'Cms',
            fields: {
                id: 'Id',
                title: 'Title',
                description: 'Descripton',
                content: 'Content',
                images: 'Images',
                featured_image: 'Featured image',
                type: 'Type',
                template: 'Template'
            }
        }
    },
};

export default customEnglishMessages;
